import Authorizer from '@gsm/authorizer'
import activityMapping from '../../../node_modules/@gsm/authorizer/lib/feature-policy/activity-mapping.json'

export const navPolicyMap = {}

const generateNavPolicyMapKeys = () => {
    Object.keys(activityMapping).forEach(service => {
        Object.keys(activityMapping[service]).forEach(activity => {
            const action = `${service}${activity}`
            navPolicyMap[action] = activityMapping[service][activity]
        })
    })
}

generateNavPolicyMapKeys()

export default class AccessPolicyService {

    constructor(policyDocument) {
        this._authorizer = Authorizer.create(policyDocument)
    }

    allows(action, orn) {
        return this._authorizer.canI(action, orn)
    }

    _getOrnSuffix(resourceName) {
        switch (resourceName) {
            case undefined:
            case '':
            case 'entity':
                return ''
            case '*':
                return ':*'
            default:
                return `:${resourceName}:*`
        }
    }

    allowNav(navPolicy, workspace) {
        if (!navPolicy) {
            return false
        }

        const { action, resourceName } = navPolicy

        const ornSuffix = this._getOrnSuffix(resourceName)
        const orn = workspace.orn + ornSuffix

        if (action === '*') {
            return true
        }

        if (!action || !action.length) {
            return false
        }

        const filteredActions = action.filter(a => {
            const [service] = a.split(':')

            // TODO: this is a temporary fix for the permissions
            // the correct fix will require extentive restructure
            // authorizer's actions
            return (workspace.isAccount && service !== 'silo') ||
                (!workspace.isAccount && service !== 'account')
        })

        for (const policyEntry of filteredActions) {
            if (!this.allows(policyEntry, orn))
                return false
        }

        return true
    }
}



// WEBPACK FOOTER //
// src/services/access-policy/index.js